import React, { useEffect } from "react";
import { styled, Paper, Badge, Box } from "@mui/material";
import { Formik, Form } from "formik";

// import SearchField from "../SearchField";
import TextButton from "../TextButton";
import CustomSelectV2 from "../CustomSelectV2";
import DateTimePicker from "../DateTimePicker";
import { getDirtyValuesCount, initialFilters } from "../../../utils/filters";
import { loadCounties } from "../../Swift/state/actions";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

const FiltersContainers = styled(({ children, ...props }) => (
  <Paper {...props} elevation={1} square>
    {children}
  </Paper>
))(({ theme }) => ({
  display: "flex",
  justifyContent: "start",
  alignItems: "center",
  height: "68px",
  borderBottom: "1px solid #E7E9EF",
  background: "#fff",
}));

const FiltersWrapper = styled(Form)(({ theme }) => ({
  display: "flex",
  justifyContent: "start",
  alignItems: "center",
  padding: 24,
  gap: 10,
  width: "100%",
}));

const messageDirections = [
  { id: "ALL", label: "ALL", value: "" },
  { id: "IN", label: "Incoming", value: "INCOMING" },
  { id: "OUT", label: "Outgoing", value: "OUTGOING" },
];

const initialValues = initialFilters;

const FiltersForm = ({
  actions,
  filters,
  values,
  setValues,
  resetForm,
  handleFiltersChange,
  handleResetFilters,
  handleToggleRenderAllFilters,
  type,
  dateOnly,
  changeSearchParams,
}) => {
  const dispatch = useDispatch();
  const countries = useSelector((state) => state.swiftMessages.countries.items);
  const [searchParams, setSearchParams] = useSearchParams();

  const dirtyFiltersCount = getDirtyValuesCount(
    { ...initialValues },
    { ...initialValues, ...filters }
  );

  const handleChange = (newValues) => {
    setValues({ ...values, ...newValues });
    handleFiltersChange({ ...values, ...newValues });

    if (changeSearchParams) {
      searchParams.set("dateTimeFrom", newValues.dateTimeFrom);
      searchParams.set("dateTimeTo", newValues.dateTimeTo);
      setSearchParams(searchParams);
    }
  };

  const getDirectionValue = () => {
    const value = messageDirections.find(
      (direction) => values.direction === direction.value
    );

    return value || messageDirections[0];
  };

  useEffect(() => {
    dispatch(loadCounties());
  }, [dispatch]);

  return (
    <>
      <FiltersContainers>
        <FiltersWrapper>
          {/* <SearchField /> */}
          <Box sx={{ minWidth: 350 }}>
            <DateTimePicker
              label="Date/Time"
              icon="calendar"
              onChange={(value) => {
                handleChange({ ...values, ...value });
              }}
              showTooltip
              dateTimeFrom={values.dateTimeFrom}
              dateTimeTo={values.dateTimeTo}
              type={type}
            />
          </Box>
          {!dateOnly && (
            <>
              {" "}
              <CustomSelectV2
                label="Message Way"
                value={getDirectionValue()}
                options={messageDirections}
                onChange={(e, direction) => {
                  handleChange({
                    ...values,
                    direction: direction.value,
                  });
                }}
                width={200}
              />
              <CustomSelectV2
                label="Countries"
                options={countries}
                getOptionLabel={(option) => option.name}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(e, countries) => {
                  handleChange({
                    ...values,
                    countries: countries.map((country) => country.code),
                  });
                }}
                value={values.countries.map((code) =>
                  countries.find((country) => country.code === code)
                )}
                limitTags={1}
                multiple
                width={200}
                disableCloseOnSelect
              />
              <TextButton
                sx={{ color: "#007AFF" }}
                onClick={handleToggleRenderAllFilters}
              >
                All Filters
              </TextButton>
            </>
          )}
          <TextButton
            sx={{ color: "#050D2E" }}
            endIcon={
              <Badge
                badgeContent={dirtyFiltersCount}
                sx={{
                  margin: 1,
                  "& .MuiBadge-badge": {
                    color: "#1C2238",
                    backgroundColor: "#D4EDF3",
                  },
                }}
              />
            }
            onClick={() => {
              resetForm({ ...initialValues });
              handleResetFilters();
            }}
          >
            Clear
          </TextButton>

          {actions}
        </FiltersWrapper>
      </FiltersContainers>
    </>
  );
};

const FiltersHeader = ({
  actions = <></>,
  filters,
  handleFiltersChange,
  handleToggleRenderAllFilters,
  handleResetFilters,
  type,
  dateOnly = false,
  changeSearchParams = false,
}) => {
  return (
    <Formik
      initialValues={{
        dateTimeFrom: filters.dateTimeFrom,
        dateTimeTo: filters.dateTimeTo,
        direction: filters.direction,
        countries: filters.countries,
      }}
      enableReinitialize
    >
      {({ initialValues, values, setValues, resetForm }) => {
        return (
          <FiltersForm
            {...{
              actions,
              filters,
              initialValues,
              values,
              setValues,
              resetForm,
              handleFiltersChange,
              handleToggleRenderAllFilters,
              handleResetFilters,
              type,
              dateOnly,
              changeSearchParams,
            }}
          />
        );
      }}
    </Formik>
  );
};

export default FiltersHeader;
